import { Countries, Currencies, DistanceUnit, IntlSettings, Locales } from '@grandvisionhq/state'

export const INTL_SETTINGS: IntlSettings = {
  country: Countries.FR,
  locale: Locales['fr-FR'],
  currency: Currencies.EUR,
  distanceUnit: DistanceUnit.km,
}
